enum InterestPaymentStrategyEnum {
    Off = 'OFF',
    Reinvest = 'REINVEST',
    Withdraw = 'WITHDRAW',
}

export default InterestPaymentStrategyEnum;
